<template>
  <div class="pa-12 d-flex justify-center flex-column align-center">
    <h1 class="mb-4">Recurso não disponível</h1>
    <p>Você não tem permissão para acessar este recurso.</p>
    <v-btn depressed color="fmq_gray" dark outlined @click="logout">
      <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
    >
  </div>
</template>

<script>
export default {
  name: "NotAvailable",
  methods: {
    async logout() {
      window.location = process.env.VUE_APP_LOGIN;
    },
  },
};
</script>

<style></style>
